import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/performance_analytics/lib/CollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
